<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="expand" class="sidebar-logo-link-fold" to="/">
        <svg-icon icon-class="logo-close" class="all-logo logo-close" />
      </router-link>
      <router-link v-else key="collapse" class="sidebar-logo-link-fold" to="/">
        <svg-icon icon-class="logo-open" class="all-logo logo-open" />
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: 'Pop HR'
    }
  }
}
</script>

<style lang="scss" scoped>
.all-logo {
  height: 30px !important;
  width: 112px !important;
  margin-right: 0 !important;
  position: absolute;
  left: 15px;
  top: 9px;
}
.all-logo.logo-open {
  height: 30px !important;
  width: 100px !important;
}
.logo-close {
  width: 28px !important;
  left: 10px;
}
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  box-shadow: 2px 0 8px 0 rgba(29, 35, 41, 0.3);
  position: relative;
  width: 230px; //$sideBarWidth;
  display: inline-block;
  height: $navHeight;
  line-height: $navHeight;
  @media screen and (max-width: $media) {
    height: $mediaNavHeight;
    line-height: $mediaNavHeight;
  }
  background: $menuBg;
  text-align: center;
  overflow: hidden;
  transition: all 0.28s;
  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    position: relative;
    h1 {
      width: 100%;
      text-align: left;
      line-height: $navHeight;
      color: #fff;
      font-weight: 700;
      font-size: 16px;
      vertical-align: middle;
      animation: fade-in;
      animation-duration: 0.2s;
      font-family: system-ui;
      margin: 0;
      .sidebar-logo {
        transform: translateY(-5px);
        margin: 0 5px 0 15px;
        height: 24px;
      }
    }
    & .sidebar-logo {
      height: 24px;
      vertical-align: middle;
      background: transparent;
      border-radius: 6px;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
